import React from "react";
import { CTA_COPY } from "./hero/heroContent";

const StickyCtaBar = ({ onOpenSignup, entryLine }) => (
  <div
    className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#0F1115]/95 backdrop-blur-lg border-t border-white/10 px-4 py-3 safe-area-pb"
    data-testid="sticky-cta-bar"
  >
    <button
      type="button"
      onClick={onOpenSignup}
      className="w-full py-3.5 rounded-lg font-heading font-bold text-sm text-white bg-gradient-to-r from-orange-500 to-red-600"
    >
      {CTA_COPY.headerButton}
    </button>
    <p
      className="text-center text-[10px] text-[#9CA3AF] mt-1.5 font-body"
      data-testid="landing-catalog-price"
    >
      {entryLine}
    </p>
  </div>
);

export default StickyCtaBar;
